module.exports = "/assets/images/ico-pdf.0fc14149.png";